export default __webpack_public_path__ + "static/media/info.34c3a62e.svg";